import React, { useEffect } from 'react';
import '../styles/ContactUs.css';
import { translations } from '../translations';

const ContactUs = ({ language }) => {
  const t = translations[language];
  const contactData = t.contactUs.contacts;
  const baseUrl = process.env.PUBLIC_URL || '';

  useEffect(() => {
    const contactImages = [
      `${baseUrl}/assets/N. A. HARIS.jpg`,
      `${baseUrl}/assets/Atheeq sir.jpg`,
      `${baseUrl}/assets/Manivannan.jpeg`
    ];
    contactImages.forEach(src => {
      const img = new Image();
      img.src = src;
    });
  }, [baseUrl]);

  return (
    <section id="contact" className="contact-section">
      <div className="container">
        <div className="contact-content">
          <h2 className="section-title">{t.contactUs.title}</h2>
          
          <div className="chairmen-section">
            <div className="chairman-card">
              <img 
                src={`${baseUrl}/assets/N. A. HARIS.jpg`} 
                alt="Sri N. A. HARIS" 
                className="chairman-image"
                loading="eager"
                decoding="async"
                onError={(e) => { e.target.style.backgroundColor = '#f0f0f0'; }}
              />
              <div className="chairman-info">
                <h3 className="chairman-name">{t.contactUs.chairmen.haris.name}</h3>
                <p className="chairman-designation">{t.contactUs.chairmen.haris.designation}</p>
              </div>
            </div>
            
            <div className="chairman-card">
              <img 
                src={`${baseUrl}/assets/Atheeq sir.jpg`} 
                alt="Sri L K Atheeq" 
                className="chairman-image"
                loading="eager"
                decoding="async"
                onError={(e) => { e.target.style.backgroundColor = '#f0f0f0'; }}
              />
              <div className="chairman-info">
                <h3 className="chairman-name">{t.contactUs.chairmen.atheeq.name}</h3>
                <p className="chairman-designation">{t.contactUs.chairmen.atheeq.designation}</p>
              </div>
            </div>
            
            <div className="chairman-card">
              <img 
                src={`${baseUrl}/assets/Manivannan.jpeg`} 
                alt="Sri Major Manivannan P." 
                className="chairman-image"
                loading="eager"
                decoding="async"
                onError={(e) => { e.target.style.backgroundColor = '#f0f0f0'; }}
              />
              <div className="chairman-info">
                <h3 className="chairman-name">{t.contactUs.chairmen.manivannan.name}</h3>
                <p className="chairman-designation">{t.contactUs.chairmen.manivannan.designation}</p>
              </div>
            </div>
          </div>

          <div className="contact-table-wrapper">
            <table className="contact-table">
              <thead>
                <tr>
                  <th>{t.contactUs.tableHeaders.slNo}</th>
                  <th>{t.contactUs.tableHeaders.name}</th>
                  <th>{t.contactUs.tableHeaders.designation}</th>
                  <th>{t.contactUs.tableHeaders.contact}</th>
                </tr>
              </thead>
              <tbody>
                {contactData.map((contact, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{contact.name}</td>
                    <td>{contact.designation}</td>
                    <td>
                      <a href={`tel:${contact.contact}`} className="contact-link">
                        {contact.contact}
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
